import { Box, Checkbox, Grid } from '@factorialco/deprecated-design-system'
import {
  AtsCandidateEmailActionTypesEnum,
  AtsHiringStageNamesEnum,
} from 'generated/resources/graphql'
import { sortBy } from 'lodash'

import { useApplicationPhases } from 'modules/ats/hooks/useApplicationPhases'

import { ApplicationPhasesSelectorSkeleton } from './ApplicationPhasesSelectorSkeleton'

type SidepanelSettings = {
  [key in AtsCandidateEmailActionTypesEnum]: {
    withoutStages: AtsHiringStageNamesEnum[]
  }
}

const sidepanelSettings: SidepanelSettings = {
  reject: {
    withoutStages: [],
  },
  phase_changed: {
    withoutStages: ['new'],
  },
}

interface Props {
  onSelectPhase: (value: number) => void
  disabledApplicationPhaseIds: number[]
  checkedApplicationPhaseIds: number[]
  jobId: number
  actionType: AtsCandidateEmailActionTypesEnum
}

export const ApplicationPhasesSelector = ({
  onSelectPhase,
  checkedApplicationPhaseIds,
  disabledApplicationPhaseIds,
  jobId,
  actionType,
}: Props) => {
  const { orderedPhases, loading } = useGetOrderedPhases({
    jobId: jobId,
    actionType,
  })

  return (
    <>
      {loading ? (
        <ApplicationPhasesSelectorSkeleton />
      ) : (
        <Grid variant="fixed">
          {orderedPhases.map((phase) => (
            <Box gridColSpan={{ xxs: 1, xs: 6 }} key={phase.id} component="li">
              <Checkbox
                disabled={disabledApplicationPhaseIds.includes(phase.id)}
                checked={checkedApplicationPhaseIds.includes(phase.id)}
                label={phase.name}
                size="large"
                onChange={() => onSelectPhase(phase.id)}
              />
            </Box>
          ))}
        </Grid>
      )}
    </>
  )
}

interface getOrderedPhasesProps {
  jobId: number
  actionType: AtsCandidateEmailActionTypesEnum
}

export const useGetOrderedPhases = ({ jobId, actionType }: getOrderedPhasesProps) => {
  // TODO: move query here
  const { applicationPhases: initialPhases, loading } = useApplicationPhases({
    variables: { atsJobPostingId: jobId },
  })

  const applicationPhases = initialPhases.filter(
    (phase) =>
      !phase.hiringStage?.name ||
      !sidepanelSettings[actionType]?.withoutStages.includes(phase.hiringStage.name)
  )

  // We do both sorting to show the phases also in the correct order of the hiring stages they belong to.
  const sortedByPhasePosition = sortBy(applicationPhases, (phase) => phase.position)
  const orderedPhases = sortBy(sortedByPhasePosition, (phase) => phase.hiringStage?.position)

  return {
    orderedPhases,
    loading,
  }
}
